import { useQuery } from "react-query";
import api from "api";
import { queryKeys } from "utils/misc";
import { supportApiBase } from "api/hooks/useHCPs";

export interface EarningsLabelTotal {
  pending: number;
  completed: number;
  discarded: number;
  total: number;
  currency: string;
}

export interface EarningsResponse {
  earnings: Record<string, Record<string, EarningsLabelTotal>>;
  total: EarningsLabelTotal;
}

export const useHcoEarnings = (hcoId: number, startTime: string, endTime: string, enabled: boolean) => {
  const key = queryKeys.hcoEarnings(hcoId, startTime, endTime);

  return useQuery(
    key,
    async () => {
      const params = new URLSearchParams({
        start_time: startTime,
        end_time: endTime,
        view: "monthly",
      });
      const response = await api.call(`/health_care_organizations/${hcoId}/earnings?${params}`, {
        root: supportApiBase,
      });
      return response.json() as Promise<EarningsResponse>;
    },
    { enabled }
  );
};
